import { iDataPanelProcessProps } from '../DataPanels/models';
import { TimelineData } from './TimelineData';
import './styles/timeline.scss';

export const Timeline = (props: iDataPanelProcessProps) => {
    //This useless file is avoiding a react hooks error
    return <TimelineData {...props}/>
};
